import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { calendarDOM, COL_TIME_WIDTH, zoomLevel } from '../styles';
import shopSelectors from 'services/selectors/shop';
import { dateParamSignal } from 'CalendarFilter/DatePicker';

const RealtimeLine = () => {
  const [currentTime, setCurrentTime] = useState<string>(moment().format());
  const salonWorkingTime = shopSelectors.salonWorkingTime();
  useEffect(() => {
    const time = setInterval(() => {
      const open = moment(`${salonWorkingTime.timeHourStart}:${salonWorkingTime.timeMinuteStart}`, 'HH:mm');
      const close = moment(`${salonWorkingTime.timeHourEnd}:${salonWorkingTime.timeMinuteEnd}`, 'HH:mm');

      const now = moment().set({ second: 0 });
      if (now.isBetween(open, close)) {
        setCurrentTime(now.format());
      } else {
        clearInterval(time);
      }
    }, 30000);
    return () => {
      clearInterval(time);
    };
  }, []);

  const getPixelPerMinute = () => {
    const className = calendarDOM.current?.className;
    if (className?.includes('zoom-level-2')) {
      return 50;
    }
    return 60;
  };

  const getSpaceAddMore = (hour: number, minute: number) => {
    const className = calendarDOM.current?.className;
    if (hour < 12) return 0;
    const totalMinutes = hour * 60 + minute;
    const x = className?.includes('zoom-level-2') ? 3 : 4;

    if (totalMinutes < (12 * 60 + 30)) return x;
    if (totalMinutes < (13 * 60 + 30)) return x + 2;
    if (totalMinutes < (14 * 60 + 30)) return x + 4;
    if (totalMinutes < (16 * 60 + 30)) return x + 8;
    if (totalMinutes < (17 * 60 + 30)) return x + 10;
    if (totalMinutes < (18 * 60 + 30)) return x + 12;
    if (totalMinutes < (19 * 60 + 30)) return x + 16;

    if (totalMinutes < (20 * 60 + 30)) return x + 18;
    if (totalMinutes < (21 * 60 + 30)) return x + 20;
    if (totalMinutes < (22 * 60 + 30)) return x + 22;
    return 0;
  };

  const top = useMemo(() => {
    const open = moment(`${salonWorkingTime.timeHourStart}:${salonWorkingTime.timeMinuteStart}`, 'HH:mm');
    const close = moment(`${salonWorkingTime.timeHourEnd}:${salonWorkingTime.timeMinuteEnd}`, 'HH:mm');
    const now = moment(currentTime);
    if(!dateParamSignal.value?.isSame(now, 'date')) return 0;
    const currentSpaceMinutes = now.diff(open, 'minutes');

    const pixel_value = getPixelPerMinute();
    const RowHeight = pixel_value + 2;
    let space = 0;

    if (now.isBetween(open, close))
      space = (RowHeight / 15) * currentSpaceMinutes;
    return Math.round(space) + getSpaceAddMore(now.get('hours'), now.get('minutes'));
  }, [currentTime, zoomLevel.value, salonWorkingTime]);

  if (!top) return null;

  return (
    <RealtimeLineStyled className='RealtimeLineStyled' style={{ top, left: COL_TIME_WIDTH }}>
      <div className='circle left'></div>
      <div className='line'></div>
      <div className='circle'></div>
    </RealtimeLineStyled>
  );
};

export default RealtimeLine;

const RealtimeLineStyled = styled.div`
position: absolute;
left: 0;
right: 0;
top: 0;
z-index: 14;
display: flex;
align-items: center;
.line {
  height: 2px;
  background: #e95060;
  width: 100%;
}
.circle {
  width: 10px;
  height: 10px;
  background: #e95060;
  border-radius: 30px;
  &.left {
    position: sticky;
    left: 0;
    z-index: 11;
  }
}
`;